import React, { useEffect, useState } from "react";
import ContentLoader from "react-content-loader";

const BASE_SCREEN_WIDTH = 390;
const BASE_MAIN_CONTENT_WIDTH = 360;

export const MobileMainSkeleton = ({ locals }) => {
  const webAppTheme = locals.activeUser.webAppTheme || "dark";
  const backgroundColor = webAppTheme === "dark" ? "#363C43" : "#F1F3F6";
  const foregroundColor = webAppTheme === "dark" ? "#40464D" : "#E0E4EA";
  const [chartSize, setChartSize] = useState({ width: 360, height: 200 });

  useEffect(() => {
    if (window) {
      const windowWidth = window.innerWidth;
      const chartWidth =
        (windowWidth * BASE_MAIN_CONTENT_WIDTH) / BASE_SCREEN_WIDTH;
      setChartSize({ ...chartSize, width: chartWidth });
    }
  }, []);

  return (
    <ContentLoader
      className="only-show-mobile"
      width={"100%"}
      height={chartSize.height}
      viewBox={`0 0 ${chartSize.width} ${chartSize.height}`}
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      speed={1}
      title="Loading metrics..."
    >
      <rect x="0" y="0" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="38" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="76" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="114" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="152" rx="3" ry="3" width="100%" height="33" />
    </ContentLoader>
  );
};
